import { sumBy } from 'lodash-es';
import { Basket, BasketItem } from '../client/src';

export const getQuantityOfItemCurrentlyInBasket = (
  basket: Basket,
  ticketID: number
) => {
  if (!basket || !basket.basketItems || basket.basketItems.length === 0) {
    return 0;
  }

  const allMatchingItems = basket.basketItems.filter(
    (basket: BasketItem) => basket.ticketID === ticketID
  );

  return sumBy(allMatchingItems, (item: BasketItem) => item.quantity);
};

export const shouldDeleteBasket = ({
  requestQuantity,
  currentItemQuantityInBasket,
  totalItemsQuantityCurrentlyInBasket,
}: {
  requestQuantity: number;
  currentItemQuantityInBasket: number;
  totalItemsQuantityCurrentlyInBasket: number;
}) => {
  return (
    requestQuantity === 0 &&
    currentItemQuantityInBasket === totalItemsQuantityCurrentlyInBasket &&
    currentItemQuantityInBasket > 0
  );
};
